import api from '@/api/index'

// 登录
export function handleLogin(data) {
    return api({
        url: '/api/user/login/pwd',
        method: 'post',
        data
    })
}

// 发送短信
export function sendSms(data) {
    return api({
        url: '/api/common/sendSms',
        method: 'post',
        data
    })
}

// 获取我的信息
export function getUserInfo(params) {
    return api({
        url: '/api/user/profile',
        method: 'get',
        params
    })
}

// 登录（短信验证码）
export function smsLogin(data) {
    return api({
        url: '/api/user/smsLogin',
        method: 'post',
        data
    })
}

// 登录（图形验证码）
export function checkCaptcha(params) {
    return api({
        url: '/api/common/checkCaptcha',
        method: 'get',
        params
    })
}

// 登录 - 获取协议列表
export function getAgreementList(params) {
    return api({
        url: '/api/agreement/list',
        method: 'get',
        params
    })
}

// 获取地区分级
export function getRegion(params) {
    return api({
        url: '/api/common/region/getItem',
        method: 'get',
        params
    })
}

// 获取地区分级
export function getExpressList(params) {
    return api({
        url: '/api/common/express/list',
        method: 'get',
        params
    })
}
